/**
 * @generated SignedSource<<283ecd44f5eed091a9499488de25a5fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CommentsList_comments",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Comment_comment"
    }
  ],
  "type": "Comment",
  "abstractKey": null
};

node.hash = "537d5695f22850e8f3abfe1c3c551ddd";

module.exports = node;
